module.exports = __webpack_public_path__ + "static/media/searchFilter.80fa4f65.svg";